export function filterCustomScripts() {
    if (document.getElementById('category-filter') && document.getElementById('categoryTriggerButton')) {
        let filterCloser = document.getElementById('close-filter');
        let filterWrapper = document.getElementById('category-filter');
        let filterButton = document.getElementById('categoryTriggerButton');
        let clickFlag = false;
        if (filterCloser) {
            filterCloser.addEventListener('click', function () {
                if (!filterWrapper)
                    return;
                if (!filterWrapper.classList.contains('closed')) {
                    filterWrapper.classList.add('closed');
                    setTimeout(function () {
                        filterWrapper.classList.add('hide-filter');
                    }, 500);
                }
            });
        }
        document.addEventListener('click', function (event) {
            if (!clickFlag || !filterButton || !filterWrapper) {
                clickFlag = true;
                if (filterButton.id === event.target.id ||
                    filterButton.id === event.target.parentNode.id ||
                    filterWrapper.id === event.target.id ||
                    filterWrapper.id === event.target.parentNode.id) {
                    if (filterWrapper.classList.contains('closed')) {
                        filterWrapper.classList.remove('hide-filter');
                        filterWrapper.classList.remove('closed');
                    }
                    else {
                        filterWrapper.classList.add('closed');
                        setTimeout(function () {
                            filterWrapper.classList.add('hide-filter');
                        }, 500);
                    }
                }
                setTimeout(function () {
                    clickFlag = false;
                }, 500);
            }
        });
    }
}
